import styled from "styled-components";

export const ButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  position: relative;
  user-select: none;
`;
